export type ExternalApiDtoVariant = "GENERAL" | "WALTER" | "SCHENKER" | "SCHENKER_V2";
export type ExternalApiCountryCodeMode = "SELF_FIXING" | "PASSTHROUGH" | "MPZ_FROM_ISO";
export type ExternalApiDateAlignmentMode = "NONE" | "FULL_DAY" | "START_OF_DAY";
export type ExternalApiIpAccessMode = "ALL" | "WHITELIST";

export class ExternalApiCityOverride {
    id?: number;
    cityIn: string = "";
    cityOut: string = "";
}

export class ExternalApiAllowedIp {
    id?: number;
    ipOrCidr: string = "";
    description?: string;
}

export class ExternalApiClient {
    id?: number;
    slug: string = "";
    name?: string;
    enabled: boolean = false;
    provozovnaId?: number;
    /** Editovatelný kód provozovny — backend ho při uložení převede na provozovnaId. */
    provozovnaKod?: string;

    dtoVariant: ExternalApiDtoVariant = "GENERAL";
    weightDivider: number = 1;
    countryCodeMode: ExternalApiCountryCodeMode = "SELF_FIXING";
    dateAlignmentMode: ExternalApiDateAlignmentMode = "NONE";
    addEmailToOffer: boolean = false;

    ipAccessMode: ExternalApiIpAccessMode = "ALL";
    rateLimitPerMin?: number;
    maxPayloadBytes?: number;

    // Hodnoty se vykreslí v exportované OpenAPI definici jako examples.
    exampleLogin?: string;
    exampleContactName?: string;
    exampleContactEmail?: string;
    exampleContactPhone?: string;
    exampleContactMobile?: string;

    cityOverrides: ExternalApiCityOverride[] = [];
    allowedIps: ExternalApiAllowedIp[] = [];
}
